/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import * as Common from '../components/Common';

class RecogTypePop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recogType: this.props.recogType,
      recogTypes: this.props.recogType ? this.props.recogType.split(',') : [],
      style: null,
      recogTypeList: [
        {type: "지인소개", text: "지인소개"},
        {type: "간판 및 현수막", text: "간판 및 현수막"},
        {type: "X 배너", text: "X 배너"},
        {type: "전단지 및 홍보 판촉물", text: "전단지 및 홍보 판촉물"},
        {type: "타센터 이용", text: "타센터 이용"},
        {type: "네이버 지도 검색", text: "네이버 지도 검색"},
        {type: "지점 블로그", text: "지점 블로그"},
        {type: "지점 인스타그램", text: "지점 인스타그램"},
        {type: "일반 블로그 이용 후기", text: "일반 블로그 이용 후기"},
        {type: "토즈 공식 인스타그램", text: "토즈 공식 인스타그램"},
        {type: "토즈 공식 블로그", text: "토즈 공식 블로그"},
        {type: "기타", text: "기타"}
      ]
    };
  }

  componentDidMount() {
    this.setState({ style: Common.getCenterPosStyle(this.layer) });
  }

  _doChangeRecogTypeEvent = (e) => {
    var _selRecogType = e.target.dataset.recogtype;
    // var _recogTypes = this.state.recogTypes;
    // if(_recogTypes.includes(_selRecogType)) {
    //   for(var idx in _recogTypes) {
    //     if(_recogTypes[idx] == _selRecogType) {
    //       _recogTypes.splice(idx, 1);
    //       break;
    //     }
    //   }
    // } else {
    //   _recogTypes.push(_selRecogType);
    // }

    this.setState({
      recogTypes: _selRecogType,
      recogType: _selRecogType
    });
  }

  render() {
    return (
      <div className="layer-pop" id="recog-pop" style={this.state.style} ref={ref => this.layer = ref}>	
	      <div className="bg" data-recogtype={this.state.recogType} data-type="recogType" onClick={this.props.onClick} ref={ref => this.layerBg = ref}></div>
        <ul className="sel-list-pop scroll">
          {this.state.recogTypeList.map((entity, index) => <li key={index} className={this.state.recogTypes.includes(entity.type) ? 'active' : ''}><a href={null} data-active={this.state.recogTypes.includes(entity.type) ? 'active' : ''} data-recogtype={entity.type} onClick={this._doChangeRecogTypeEvent.bind(this)}>{entity.text}</a></li>)}
        </ul>
        <div className="loca-seach-pop">
          <a href={null} className="check-btn" data-recogtype={this.state.recogType} data-type="recogType" onClick={this.props.onClick}>확인</a>
        </div>
      </div>
    )
  }
}

export default RecogTypePop;